<res-project-panel *ngIf="projects"
    [editMode]="editMode"
	[dDKey]="dDKeyProject"
	[selectedProjects]="projects"
    [hisDynamicContent]="'fs.res.common.projects'"
	[dynamicComponent]="dynamicComponent"
	(selectedProjectsChange)="onProjectsChange($event)">
</res-project-panel>

<res-publication-panel *ngIf="publications"
    [editMode]="editMode"
	[dDKey]="dDKeyPublication"
	[selectedPublications]="publications"
	[isOptional]="publicationsAreOptional"
	(selectedPublicationsChange)="onPublicationsChange($event)">
</res-publication-panel>

<res-doctorate-panel *ngIf="doctorates"
	[dDKey]="dDKeyDoctorates"
	[selectedDoctorates]="doctorates"
	(selectedDoctoratesChange)="onDoctoratesChange($event)">
</res-doctorate-panel>

<res-infrastructure-panel *ngIf="researchInfrastructures"
    [editMode]="editMode"
    [dDKey]="dDKeyResearchInfrastructures"
    [selectedInfrastructures]="researchInfrastructures"
    (selectedInfrastructuresChange)="onInfrastructuresChange($event)"
    (onBeforeNavigate)="onBeforeNavigate.emit($event)">
</res-infrastructure-panel>
